export default "__VITE_ASSET__CpG2_ETm__"